// src/pages/HomePage.jsx
import React from "react";

// Importing all the new child components
import CurrentStatusCard from "../components/home/CurrentStatusCard";
import Instance from "../components/home/Instance";
import LocationMapCard from "../components/home/LocationMapCard";
import ParkingBanner from "../components/home/ParkingBanner";
import QuickActionsCard from "../components/home/QuickActionsCard";
import Breadcrumb from "../components/Breadcrumb";

const HomePage = () => {
  

  return (
    <>
      <style>
        {`
       
          .text-shadow-strong { text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6); }
          .text-shadow-light { text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5); }
          .icon-circle {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .bg-light-success { background-color: rgba(25, 135, 84, 0.1); }
          .bg-light-warning { background-color: rgba(255, 193, 7, 0.1); }
          .bg-light-danger { background-color: rgba(220, 53, 69, 0.1); }
          .card {
            border: none;
            border-radius: 0.75rem;
          }
          .status-dot {
            height: 8px;
            width: 8px;
            border-radius: 50%;
            display: inline-block;
          }
          .quick-action-item {
            cursor: pointer;
            padding: 0.75rem;
            border-radius: 0.5rem;
            transition: background-color 0.2s ease-in-out;
          }
          .quick-action-item:hover {
            // background-color: #3c454eff;
          }
          .btn-danger-600 {
            background-color: #dc3545;
            color: white;
          }
          .btn-danger-600:hover {
            background-color: #bb2d3b;
            color: white;
          }
        `}
      </style>
      <Breadcrumb title="Home" />

      <div className="container-fluid p-4">
        <div className="row g-4">
          {/* Left Column */}
          <div className="col-lg-8">
            <div className="row g-4">
              <div className="col-12">
                <ParkingBanner />
              </div>

              {/* Recent Parking Activity */}
              <div className="col-12">
                <Instance />
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-4">
            <div className="d-flex flex-column gap-4">
              <CurrentStatusCard />
              <LocationMapCard />
              <QuickActionsCard />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
